import { EmploymentStatus, VgEmploymentState } from '@interfaces';
import { createSelector } from '@ngrx/store';

import { selectEmploymentMfeDataByOwnerIndex } from '../../open-account/open-account.selectors';
import { nullState } from '../common/router.selectors';
import {
  getInheritedIraReviewNextPage,
  getInheritedIraTermsNextPage,
} from './inherited-ira-router.helper';

export const selectInheritedIraDecedentInfoNextPage = createSelector(
  nullState,
  () => 'secure/inherited-ira/personal-info',
);

export const selectInheritedIraPersonalInfoNextPage = createSelector(
  nullState,
  () => 'secure/inherited-ira/contact-info',
);

export const selectInheritedIraContactInfoNextPage = createSelector(
  nullState,
  () => 'secure/inherited-ira/settlement-fund',
);

export const selectInheritedIraSettlementFundNextPage = createSelector(
  nullState,
  () => 'secure/inherited-ira/employment',
);

export const selectInheritedIraEmploymentNextPage = createSelector(
  selectEmploymentMfeDataByOwnerIndex(0),
  (employment: Partial<VgEmploymentState> | undefined) => {
    const isVanguardEmployee =
      employment?.employmentStatus?.employmentStatus === EmploymentStatus.VANGUARD_EMPLOYED;
    const isSpouseVanguardEmployee = employment?.associations?.spouse ?? false;
    const isAssociatedPerson = employment?.associations?.associated ?? false;

    if (isAssociatedPerson && !isVanguardEmployee && !isSpouseVanguardEmployee) {
      return 'secure/inherited-ira/upload/letter';
    }
    return 'secure/inherited-ira/income-net-worth';
  },
);

export const selectInheritedIraLetterUploadNextPage = createSelector(
  nullState,
  () => 'secure/inherited-ira/income-net-worth',
);

export const selectInheritedIraIncomeNetWorthNextPage = createSelector(
  nullState,
  () => 'secure/inherited-ira/investment-objectives',
);

export const selectInheritedIraInvestmentObjNextPage = createSelector(
  nullState,
  () => 'secure/inherited-ira/review',
);

export const selectInheritedIraReviewNextPage = createSelector(nullState, () =>
  getInheritedIraReviewNextPage(),
);

export const selectInheritedIraTermsNewNextPage = createSelector(nullState, () =>
  getInheritedIraTermsNextPage(),
);
